import { Box, Checkbox, HStack, VStack } from "@chakra-ui/react";
import React, { useState } from "react";
import Breadcrumbs from "../../components/Shared/Breadcrumbs/Breadcrumbs";
import LoadingIndicator from "../../components/Shared/LoadingIndicator/LoadingIndicator";
import LogRow from "../../components/Shared/LogRow/LogRow";
import { ApiLogsBreadcrumbs } from "../../configs/breadcrumbNavigation";
import { useDevLogByOrganisation } from "../../networking/dev-log.hooks";

const SUCCESS_STATUS_CODES = [200, 226];
const CLIENT_ERROR_STATUS_CODES = [400, 451];
const SERVER_ERROR_STATUS_CODES = [500, 511];

const ApiLogsPage: React.FC = () => {
	const [statusCodes, setStatusCodes] = useState(["2xx", "4xx", "5xx"]);

	const { data, isLoading } = useDevLogByOrganisation({
		status: statusCodes.flatMap((item) => {
			switch (item) {
				case "2xx":
					return SUCCESS_STATUS_CODES;
				case "4xx":
					return CLIENT_ERROR_STATUS_CODES;
				case "5xx":
					return SERVER_ERROR_STATUS_CODES;
				default:
					return [];
			}
		}),
	});

	function handleCheck(e: React.ChangeEvent<HTMLInputElement>) {
		const { value, checked } = e.target;

		if (checked) {
			setStatusCodes((prev) => [...prev, value]);
		} else {
			setStatusCodes((prev) => prev.filter((item) => item !== value));
		}
	}

	return (
		<>
			<Breadcrumbs items={ApiLogsBreadcrumbs} />
			<div className="p-4 px-6">
				<Box>
					<HStack spacing={5} direction="row" mb="3">
						<Checkbox value={"2xx"} isChecked={statusCodes.includes("2xx")} onChange={handleCheck}>
							Success (2xx)
						</Checkbox>
						<Checkbox value="4xx" isChecked={statusCodes.includes("4xx")} onChange={handleCheck}>
							Client error (4xx)
						</Checkbox>
						<Checkbox value="5xx" isChecked={statusCodes.includes("5xx")} onChange={handleCheck}>
							Server error (5xx)
						</Checkbox>
					</HStack>
					{isLoading ? (
						<LoadingIndicator />
					) : (
						<VStack w="full" alignItems={"flex-start"} spacing={"0"}>
							{data?.map((item) => (
								<LogRow value={item} key={item.transactionId} />
							))}
						</VStack>
					)}
				</Box>
			</div>
		</>
	);
};

export default ApiLogsPage;
